import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, AppBar, IconButton, Typography, Toolbar, DialogContent, DialogActions, Grid, Button  } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const StandardDialog = props => {
    const { handleClose, open, title, children, fullScreen = true } = props
    return (
        <Dialog
            fullScreen={fullScreen}
            aria-labelledby="simple-dialog-title"
            disableBackdropClick={fullScreen}
            disableEscapeKeyDown={fullScreen}
            onClose={handleClose}
            open={open}
            fullWidth
            maxWidth={!fullScreen && 'sm'}
            >
            <DialogTitle id="simple-dialog-title" >
              <Grid container justify='space-between'>
                {title}
                <IconButton onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
              </Grid>
            </DialogTitle>
            {fullScreen && <AppBar key={'dialog'}>
                <Toolbar style={{ position: 'relative', backgroundColor: "#2e2757" }}>
                    <IconButton edge="start" onClick={handleClose} aria-label="close">
                        <CloseIcon style={{color:"#FFFFFF"}}/>
                    </IconButton>
                    <Typography variant="h6" style={{ flex: 1, color: "#FFFFFF" }}>
                        {title}
                    </Typography>
                </Toolbar>
            </AppBar>}
            <DialogContent>
                {children}
            </DialogContent>

        </Dialog>
    );
};

StandardDialog.propTypes = {
    handleClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired,
};

export default StandardDialog;
